module.exports = __webpack_public_path__ + "static/media/start-flag.8a751a9a.svg";